import React, { useContext, useEffect, useRef, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import {
	useAddSubmittalMutation,
	useEditSubmittalMutation,
	useGetSingleSubmittalsQuery,
	useResubmitSubmittalMutation,
} from "../../../Redux/service/Submittals/Submittals";
import * as Yup from "yup";
import { useFormik } from "formik";
import trans, { isRTL } from "../../../utils";
import { toast } from "react-toastify";
import Loader from "../../Helpers/Loader/Loader";
import OffcanvasFooter from "../../Helpers/Offcanvasfooter/OffcanvasFooter";
import SubmittalInfo from "./SubmittalInfo";
export default function SubmittalsBody() {
	const [submitAttempt, setSubmitAttempt] = useState(false);
	let {
		handleClose,
		isEditing,
		currentSubmittalId,
		setReloadData,
		attachmentsId,
		setAttachmentsId,
		form,
		resubmission,
	} = useContext(popupcontext);
	const {
		data: Editvalues,
		refetch,
		isLoading,
	} = useGetSingleSubmittalsQuery(currentSubmittalId, {
		skip: !currentSubmittalId,
	});
	let [AddSubmittal, { isLoading: AddLoading }] = useAddSubmittalMutation();
	let [EditSubmittal, { isLoading: EditLoading }] = useEditSubmittalMutation();
	const [Resubmission, { isLoading: ResubmissionLoading }] =
		useResubmitSubmittalMutation();
	const [submittalsAttachments, setsubmittalsAttachments] = useState();

	let initialValues = {
		projectId: null,
		type: null,
		discipline: null,
		description: null,
		targetReviewDate: null,
		attachments: [],
		attachmentsToDelete: null,
		comments: null,
	};
	let validSchema = Yup.object({
		projectId: isEditing
			? Yup.number().nullable()
			: Yup.number().required(trans("Project is required")),
		type: Yup.string().required(trans("Type is required")),
		discipline: Yup.string().required(trans("Discipline is required")),
	});
	let addSubmittal = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				if (isEditing) {
					console.log("val", val);
					await EditSubmittal({
						val: val,
						id: currentSubmittalId,
					}).unwrap();
					if (!resubmission) {
						toast.success(trans("Submittal Edited Successfully"), {
							autoClose: 800,
							rtl: localStorage.getItem("lang") === "ar" ? true : false,
						});
					} else {
						await Resubmission({
							id: currentSubmittalId,
							val: val.comments,
						}).unwrap();
						toast.success(
							trans("Submittal Re-Submission Submitted Successfully"),
							{
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar" ? true : false,
							}
						);
					}
					setReloadData(true);
					refetch();
					setsubmittalsAttachments([]);
					handleClose("form");
				} else {
					await AddSubmittal(val).unwrap();
					toast.success(trans("Submittal Added Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setReloadData(true);
					setSubmitAttempt(true);
					handleClose("form");
				}
			} catch (error) {
				console.log("errr", error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});

	console.log("AddSubmittal", addSubmittal);
	useEffect(() => {
		if (isEditing && Editvalues) {
			addSubmittal.setValues({
				type: Editvalues?.data?.type,
				discipline: Editvalues?.data?.discipline,
				description: Editvalues?.data?.description,
				targetReviewDate: Editvalues?.data?.targetReviewDate,
				attachments: Editvalues?.data?.attachments,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, Editvalues]);
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addSubmittal.handleSubmit(e);
	};

	useEffect(() => {
		if (attachmentsId && isEditing) {
			addSubmittal.setFieldValue("attachmentsToDelete", attachmentsId);
		}
	}, [attachmentsId, isEditing]);
	const ranOnce = useRef(false);

	useEffect(() => {
		if (
			!ranOnce.current &&
			addSubmittal?.values?.attachments?.length > 0 &&
			form
		) {
			setsubmittalsAttachments(addSubmittal.values.attachments);
			ranOnce.current = true;
		}
	}, [addSubmittal?.values?.attachments, form]);
	useEffect(() => {
		if (form === false) {
			addSubmittal.resetForm();
			ranOnce.current = false;
			setAttachmentsId([]);
		}
	}, [form]);
	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	if (EditLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<>
			<form dir={!isRTL ? "ltr" : "rtl"} onSubmit={handleSubmit}>
				<SubmittalInfo
					addData={addSubmittal}
					isEditing={isEditing}
					attachments={submittalsAttachments}
					isLoading={isLoading}
				/>
				<OffcanvasFooter addData={addSubmittal} submitAttempt={submitAttempt} />
			</form>
		</>
	);
}
